import removeFieldName from "./removeFieldName";

const cleanMessage = val => {
  if (typeof val === "string") {
    return removeFieldName(val);
  }
  if (Array.isArray(val) && val.length > 0) {
    return cleanMessage(val[0]);
  }
  if (val && typeof val === "object") {
    if (val.message) return cleanMessage(val.message);
    if (val.title) return cleanMessage(val.title);
    if (val.error) return cleanMessage(val.error);
    if (Array.isArray(val.errors) && val.errors.length > 0) {
      return cleanMessage(val.errors[0]);
    }
  }
  return typeof val === "string" ? removeFieldName(val) : null;
};

const extractFromChildren = (children, prefix = "") => {
  let result = {};
  if (!children || typeof children !== "object" || Array.isArray(children)) {
    return result;
  }

  Object.keys(children).forEach(key => {
    const item = children[key];
    if (!item || typeof item !== "object") return;

    const fullKey = prefix ? `${prefix}.${key}` : key;
    const cleanKey = fullKey.replace(/^(supplier|factorDataSheet)\./, "");

    if (item.errors && Array.isArray(item.errors) && item.errors.length > 0) {
      const msg = cleanMessage(item.errors[0]);
      if (msg) {
        result[key] = msg;
        result[fullKey] = msg;
        result[cleanKey] = msg;
      }
    }

    if (item.children) {
      const nested = extractFromChildren(item.children, fullKey);
      result = { ...result, ...nested };
    }
  });

  return result;
};

const selectFieldErrorsFromResponse = errorOrResponse => {
  const response =
    errorOrResponse && errorOrResponse.response
      ? errorOrResponse.response
      : errorOrResponse;

  if (!response || typeof response !== "object") {
    return null;
  }

  let errors = {};

  const fields = (response.errors && response.errors.fields) || response.fields;
  if (fields && typeof fields === "object" && !Array.isArray(fields)) {
    Object.entries(fields).forEach(([k, v]) => {
      const msg = cleanMessage(v);
      if (msg) {
        errors[k] = msg;
        errors[k.replace(/^(supplier|factorDataSheet)\./, "")] = msg;
      }
    });
  }

  const children =
    (response.errors && response.errors.children) || response.children;
  if (children && typeof children === "object") {
    const childrenErrors = extractFromChildren(children);
    errors = { ...errors, ...childrenErrors };
  }

  const violations =
    response.violations || (response.errors && response.errors.violations);
  if (Array.isArray(violations)) {
    violations.forEach(v => {
      const path = v.propertyPath || v.property_path || v.field;
      const msg = cleanMessage(v.message || v.title);
      if (path && msg) {
        errors[path] = msg;
        errors[path.replace(/^(supplier|factorDataSheet)\./, "")] = msg;
      }
    });
  }

  if (Array.isArray(response.errors)) {
    response.errors.forEach(item => {
      if (item && typeof item === "object") {
        const path =
          item.property_path || item.propertyPath || item.field || item.name;
        const msg = cleanMessage(item.message || item.error || item.title);
        if (path && msg) {
          errors[path] = msg;
          errors[path.replace(/^(supplier|factorDataSheet)\./, "")] = msg;
        }
      }
    });
  }

  if (
    response.errors &&
    typeof response.errors === "object" &&
    !Array.isArray(response.errors) &&
    !response.errors.children &&
    !response.errors.fields
  ) {
    Object.entries(response.errors).forEach(([k, v]) => {
      const msg = cleanMessage(v);
      if (msg) {
        errors[k] = msg;
        errors[k.replace(/^(supplier|factorDataSheet)\./, "")] = msg;
      }
    });
  }

  ["bankAccountHuf", "bankAccountEur", "bankAccountUsd"].forEach(field => {
    if (response[field]) {
      const msg = cleanMessage(response[field]);
      if (msg) {
        errors[field] = msg;
      }
    }
  });

  return Object.keys(errors).length > 0 ? errors : null;
};

export default selectFieldErrorsFromResponse;
